import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import '../alert-form.css';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import IndependentThresholdSummary from './IndependentThresholdSummary';
import {
  selectSensorsData,
  selectThresholdData,
} from '../../../../redux/slices/alertFormSlice/alertFormSlice';
import SharedThresholdSummary from './SharedThresholdSummary';

function DefineThresholdsSummary({ onEdit = null }) {
  const thresholdData = useSelector(selectThresholdData);
  const sensorsData = useSelector(selectSensorsData);
  const thresholdId = thresholdData ? thresholdData.thresholdId : -1;
  const useSharedThreshold = thresholdData ? thresholdData.useSharedThreshold : false;

  return (
    <Card className="alert-card">
      <Card.Body>
        <>
          <Row className="align-items-center">
            <Col>
              <Card.Title className="mb-0">Threshold:</Card.Title>
            </Col>
            <Col className="text-right">
              {/* eslint-disable-next-line react/button-has-type */}
              {
                onEdit
                  && (
                  <FontAwesomeIcon
                    className="btn btn-link"
                    onClick={onEdit}
                    icon={faPencil}
                  >
                    Edit
                  </FontAwesomeIcon>
                  )
              }
            </Col>
          </Row>
          {
            useSharedThreshold
              ? (
                <SharedThresholdSummary
                  thresholdId={thresholdId}
                  thresholdData={thresholdData}
                  sensorsData={sensorsData}
                />
              )
              : <IndependentThresholdSummary />
          }
        </>
      </Card.Body>
    </Card>
  );
}

DefineThresholdsSummary.defaultProps = {
  onEdit: null,
};
DefineThresholdsSummary.propTypes = {
  onEdit: PropTypes.func,
};
export default DefineThresholdsSummary;
